import { render, staticRenderFns } from "./ListInspecciones.vue?vue&type=template&id=af55a76c"
import script from "./ListInspecciones.vue?vue&type=script&lang=js"
export * from "./ListInspecciones.vue?vue&type=script&lang=js"
import style0 from "./ListInspecciones.vue?vue&type=style&index=0&id=af55a76c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports